import * as React from 'react';

import styled, { css } from 'styled-components';

import ProgressLine from './progress-line';

export type statusType = '' | 'uploading' | 'done' | 'error';

export interface UploadProps {
  className?: string;
  children?: React.ReactChild;
  status?: statusType;
  progress?: number;
  error?: React.ReactNode;
  inline?: boolean;
  noProgressline?: boolean;
  noWrapper?: boolean;

  inSidebar?: boolean;
  locked?: boolean;
  onChange: (files: File[]) => void;
}

export const Upload: React.FC<UploadProps> = (props) => {
  return (
    <div
      className={`${props.className} ${props.noWrapper ? 'noWrapper' : ''} `}
    >
      {props.children}
      {props.noProgressline ? null : props.status ? (
        <ProgressLine
          progress={props.progress}
          status={props.error ? 'error' : props.status}
        />
      ) : null}
    </div>
  );
};

export default styled(Upload)`
  z-index: 5;

  ${(props) =>
    props.inline
      ? css`
          background-color: transparent;
        `
      : null}

  ${(props) =>
    props.inline && props.error
      ? css`
          border-color: ${({ theme }) => theme.colors.error};
        `
      : null}
`;
